import { useEffect, useState } from "react";
import { supabase } from "../supabase";
import { Logger } from "../logger/Logger";

const POLL_INTERVAL = 600000; // 10 minutes

export const useReleaseCheck = (
	appInitializedAt: string | null,
	app: "dentlab" | "dentconnect"
) => {
	const [hasNewRelease, setHasNewRelease] = useState(false);

	const checkForNewRelease = async () => {
		if (!appInitializedAt) return;

		try {
			const { data, error } = await supabase
				.from("releases")
				.select("created_at")
				.or(`app.is.null,app.eq.${app}`)
				.order("created_at", { ascending: false })
				.limit(1)
				.single();

			if (error) {
				Logger.error(error, {}, "Error checking for new release");
				return;
			}

			if (data?.created_at) {
				const latestReleaseTime = new Date(data.created_at).getTime();
				const appInitTime = new Date(appInitializedAt).getTime();

				if (latestReleaseTime > appInitTime) {
					setHasNewRelease(true);
				}
			}
		} catch (error) {
			Logger.error(error, {}, "Error checking for new release");
		}
	};

	useEffect(() => {
		checkForNewRelease();

		const interval = setInterval(() => {
			checkForNewRelease();
		}, POLL_INTERVAL);

		return () => clearInterval(interval);
	}, [appInitializedAt, app]);

	return { hasNewRelease };
};
